import isUrl from 'is-url';
import { getEventTransfer } from 'slate-react';
import 'whatwg-fetch';

export default function embedTweet(options) {
  return {
    onPaste(event, change, editor) {
      const transfer = getEventTransfer(event);
      const { text, type } = transfer;

      // If pasting anything that's not text or html, fall through.
      if (type !== 'text' && type !== 'html') return;
      // If not a YouTube video link, fall through.
      if (!this.isYouTubeVideo(text)) return;

      this.handleVideo(text, change, editor);
    },

    /**
     * Check if text is a URL and is from YouTube.
     */
    isYouTubeVideo(text) {
      if (!isUrl(text)) return false;
      if (text.indexOf('youtube.com') > -1) return true;
      return false;
    },

    /**
     * Adds a temporary loading spinner and then adds correct state for
     * video once fetched from oEmbed endpoint.
     */
    async handleVideo(url, change, editor) {
      const tempState = change.insertBlock({
        type: 'loading-spinner',
        isVoid: true,
      });

      editor.onChange(tempState);

      const data = await this.fetchOembed(url);

      const newState = change.undo().delete().insertBlock({
        type: 'youtube',
        isVoid: true,
        data: data,
      }).insertBlock('paragraph');

      editor.onChange(newState);
    },

    /**
     * Grab oEmbed data from our endpoint.
     */
    async fetchOembed(url) {
      const response = await fetch(options.oembedAPI, {
        method: 'POST',
        headers: {
          'Authorization': options.authorization || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          url: url,
        }),
      });

      const data = await response.json();
      return data;
    },
  };
}
